module.exports = "/fonts/PT Root UI_Medium.eot?16a6dfe4c2eae9c95156713e6fc82bc5";